// Home.js
import React, { useState, useEffect } from 'react';
import './Home.css';

const Home = () => {
  // Array of images for the auto-slider
  // Replace these paths with your actual phone mockup screenshots
  const sliderImages = [
    '/img/ca.png',
    '/img/tf.png',
    '/img/ka.png',
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-slide logic: changes image every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % sliderImages.length);
    }, 3000); // 3000ms = 3 seconds

    return () => clearInterval(interval);
  }, [sliderImages.length]);

  return (
    <section className="home-section">
      <div className="home-container">
        {/* Left Side: Content */}
        <div className="home-content">
          {/* Location Badge */}
          <div className="home-badge">
            <span className="badge-dot"></span>
            SERVING COIMBATORE, TAMIL NADU
          </div>

          {/* Main Heading */}
          <h1 className="home-title">
            Everything You Need, <br />
            <span className="home-title-highlight">Just a Tap Away</span>
          </h1>

          {/* Subtitle */}
          <p className="home-subtitle">
            Book car washes, turf slots and tournaments easily through our mobile app.
          </p>

          {/* Store Buttons */}
          <div className="home-store-buttons">
            <a
              href="https://apps.apple.com/us/app/qslot/id6747074785"
              target="_blank"
              rel="noopener noreferrer"
              className="home-store-btn"
            >
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
              </svg>
              <div className="home-store-text">
                <span className="home-store-sub">DOWNLOAD ON THE</span>
                <span className="home-store-main">App Store</span>
              </div>
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.fewas.qslot.user.app&hl=en-US"
              target="_blank"
              rel="noopener noreferrer"
              className="home-store-btn"
            >
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path d="M3.609 1.814L13.792 12 3.61 22.186a1.5 1.5 0 0 1-.61-1.21V3.024c0-.48.24-.91.609-1.21zM14.5 12.707l2.302 2.302-11.34 6.545 9.038-8.847zM19.79 8.51l-2.83 1.634L14.5 12l2.46 2.46 2.83 1.634a1.5 1.5 0 0 0 0-2.598v.014zM5.462 2.446L16.802 8.99 14.5 11.293 5.462 2.446z"/>
              </svg>
              <div className="home-store-text">
                <span className="home-store-sub">GET IT ON</span>
                <span className="home-store-main">Google Play</span>
              </div>
            </a>
          </div>

          {/* Bottom Note */}
          <p className="home-note">
            Download our app and book your service anytime, anywhere.
          </p>
        </div>

        {/* Right Side: Auto-Sliding Phone Mockup */}
        <div className="home-image-wrapper">
          <div className="phone-mockup">
            <div className="phone-notch"></div>
            <div className="phone-screen">
              {sliderImages.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`App Screen ${index + 1}`}
                  className={`slider-image ${index === currentSlide ? 'active' : ''}`}
                />
              ))}
            </div>
          </div>
          {/* Decorative gradient blob behind phone */}
          <div className="home-glow"></div>
        </div>
      </div>
    </section>
  );
};

export default Home;